import { fetch } from '@/utils/http'

export default {
  getUser: params => fetch('get', '/cbaas-service/v1/kjb/offchain/user', params), //获取链下用户列表

  getUserInfo: params => fetch('get', '/cbaas-service/v1/kjb/offchain/user/info', params), //获取链下用户列表

  getChan: params => fetch('get', '/cbaas-service/v1/kjb/offchain/chan/list', params), //获取用户关联通道

  getChanInfo: params => fetch('get', '/cbaas-service/v1/kjb/offchain/chan', params), //获取用户关联通道

  getTxList: params => fetch('get', '/cbaas-service/v1/kjb/offchain/tx/list', params), //链下通道交易列表

  getChanTxList: params => fetch('get', '/cbaas-service/v1/kjb/offchain/tx/chan/list', params), //链下通道内交易列表

  getChanUser: params => fetch('get', '/cbaas-service/v1/kjb/offchain/chan/user', params), //获取通道用户列表

  createChan: params => fetch('post', '/cbaas-service/v1/kjb/offchain/create', params), //创建通道

  joinChan: params => fetch('post', '/cbaas-service/v1/kjb/offchain/join', params), //加入通道

  exitChan: params => fetch('post', '/cbaas-service/v1/kjb/offchain/exit', params), //退出通道

  charge: params => fetch('post', '/cbaas-service/v1/kjb/offchain/charge', params), //充值

  initiateTx: params => fetch('post', '/cbaas-service/v1/kjb/offchain/tx', params), //发起链下通道交易

  queryTx: params => fetch('get', '/cbaas-service/v1/kjb/offchain/tx/query', params), //查询链下通道交易

  importUser: params => fetch('post', '/cbaas-service/v1/kjb/offchain/import/user', params), //获取用户列表

  pressuretTest: params => fetch('get', '/cbaas-service/v1/kjb/offchain/stress/test', params), //压力测试

  challeage: params => fetch('post', '/cbaas-service/v1/kjb/offchain/challeage', params), //模拟挑战
  doEvil: params => fetch('post', '/cbaas-service/v1/kjb/offchain/do/evil', params) //模拟作恶
}
